<template>

  <aside class="TestimonialVideoCarousel">

    <CarouselNavigationWrapper @activateNextItem="activateNextVideo" @activatePrevItem="activatePrevVideo">
      <CarouselItemsScroller v-if="content.testimonialVideos && content.testimonialVideos.length > 0"
        :numItems="content.testimonialVideos.length"
        :targetItemIndex="targetVideoIndex"
        @scroll="activateScrolledVideo"
      >
        <TestimonialVideoPreview v-for="video, index in content.testimonialVideos"
          :key="video._key"
          :content="video"
          :isActive="index === activeVideoIndex"
          @playVideo="playVideo(index)"
        />
      </CarouselItemsScroller>
    </CarouselNavigationWrapper>

    <Container v-if="content.testimonialVideos && content.testimonialVideos.length > 0" class="indicatorContainer">
      <CarouselItemsIndicator :items="content.testimonialVideos" :activeItemIndex="activeVideoIndex" />
    </Container>

    <VideoDialog ref="dialog"
      :videos="content.testimonialVideos"
      v-bind="{ activeVideoIndex, activatePrevVideo, activateNextVideo }"
    />

  </aside>

</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import CarouselItemsIndicator from '../../elems/CarouselItemsIndicator.vue'
import CarouselItemsScroller from '../../elems/CarouselItemsScroller.vue'
import CarouselNavigationWrapper from '../../elems/CarouselNavigationWrapper.vue'
import TestimonialVideoPreview from './TestimonialVideoPreview.vue'
import VideoDialog from './VideoDialog.vue'

export default {
  components: {
    CarouselItemsIndicator,
    CarouselItemsScroller,
    CarouselNavigationWrapper,
    VideoDialog,
    TestimonialVideoPreview,
  },
  props: {
    content: Object,
  },
  data() {
    return {
      activeVideoIndex: 0,
      targetVideoIndex: 0,
    }
  },
  methods: {
    activateNextVideo() {
      console.log('activateNextVideo')
      if (this.activeVideoIndex === this.content.testimonialVideos.length - 1) {
        this.targetVideoIndex = 0
      }
      else {
        this.targetVideoIndex = this.activeVideoIndex + 1
      }
    },
    activatePrevVideo() {
      console.log('activatePrevVideo')
      if (this.activeVideoIndex === 0) {
        this.targetVideoIndex = this.content.testimonialVideos.length - 1
      }
      else {
        this.targetVideoIndex = this.activeVideoIndex - 1
      }
    },
    activateScrolledVideo(ev) {
      const { target } = ev
      // The '+ 1' ensures the result can never be exactly 1
      const scrollDepth = target.scrollLeft / (target.scrollWidth - target.clientWidth + 1)
      this.activeVideoIndex = Math.floor(this.content.testimonialVideos.length * scrollDepth)
    },
    playVideo(index) {
      this.activeVideoIndex = index
      pushAnalyticsEvent({
        scope: 'videoCarousel',
        action: 'playVideo',
        content: {
          heading: "Testimonial videos",
          video: this.content.testimonialVideos[index],
        },
      })
      this.$refs.dialog.showVideo()
    },
  }
}
</script>

<style scoped>

.TestimonialVideoCarousel {
  padding-bottom: var(--spacing-12);
}

.indicatorContainer {
  margin-top: var(--spacing-10);
}
</style>
